export type ApiResponseEntryInfo = {
  type: string,
  authorization: string,
  password?: string,
  lockerAddress?: string,
  additionalInfo?: string,
}

export class EntryInfo {
  type: string;
  authorization: string;
  password: string;
  lockerAddress: string;
  additionalInfo: string;

  constructor(apiResponseEntryInfo: ApiResponseEntryInfo) {
    this.type = apiResponseEntryInfo.type;
    this.authorization = apiResponseEntryInfo.authorization;
    this.password = apiResponseEntryInfo.password;
    this.lockerAddress = apiResponseEntryInfo.lockerAddress;
    this.additionalInfo = apiResponseEntryInfo.additionalInfo;
  }
}
